import {
    Modal,
} from 'antd';
import React, {FC} from 'react';

import {TModalComponentInterface} from 'store/slices/modals-slice';

import {IntegratedFilter} from '../table/action/filters';

interface IFormModalProps extends TModalComponentInterface {
    entityName: string;
}

export const FilterModal: FC<IFormModalProps> = ({
    onClose,
    entityName,
}: IFormModalProps) => (
    <Modal
        footer={null}
        visible
        width="100vw"
        onCancel={onClose}
        maskClosable={false}
    >
        <IntegratedFilter
            isIntegratedFilter={false}
            entityName={entityName}
            onClose={onClose}
        />
    </Modal>
);
